import { useEffect, useRef } from "react"
import ReactCodeInput from "react-verification-code-input"
import styled from "styled-components"

const StyledeInput = styled(ReactCodeInput)<{
  $submitError?: string
}>`
  width: 100% !important;
  margin-top: 4px;
  margin-bottom: 4px;
  & > div {
    & > input {
      font-family: "NarkisBlock" !important;
      font-size: 24px;
      border-top-left-radius: 8px !important;
      border-top-right-radius: 8px !important;
      border-bottom-left-radius: 8px !important;
      border-bottom-right-radius: 8px !important;
      border-right: solid 1px #e5e5e5 !important;
      border-left: solid 1px #e5e5e5 !important;
      border: ${(p) =>
        p.$submitError
          ? "solid 1px rgba(215, 2, 2, 0.5)"
          : "solid 1px #E5E5E5;"} !important;

      background-color: #fff;
      margin-left: 8px;
      color: #000;
      &:first-child {
        margin-left: 0 !important;
      }

      &:focus {
        box-shadow: none;
        border: 1px solid var(--Yellow, #ffbc0d);
        border-right: solid 1px #ffbc0d !important;
        border-left: solid 1px #ffbc0d !important;
      }

      ${(p) => p.theme.breakpoints.up("md")} {
        width: 48px !important;
        height: 56px !important;
      }
      border-radius: 8px;
    }
  }
`
const StyledCodeWrapper = styled.div`
  margin: 8px auto 15px;
  width: max-content;
  direction: ltr;
`

type StyledCodeInputProps = {
  setSubmitCode: React.Dispatch<React.SetStateAction<null>>
  setDisabled: React.Dispatch<React.SetStateAction<boolean>>
  submitError: string
  setSubmitError: React.Dispatch<React.SetStateAction<null>>
  handleSubmit: (string?) => Promise<void>
  ariaLabel?: string
}

const StyledCodeInput = ({
  setSubmitCode,
  setDisabled,
  submitError,
  setSubmitError,
  handleSubmit,
  ariaLabel,
}: StyledCodeInputProps) => {
  const ref = useRef(null)

  const handleComplete = (code) => {
    setSubmitCode(code)
    setDisabled(false)
    if (submitError !== "בוצעו יותר מדי נסיונות כושלים, נסו שוב עוד דקה")
      setSubmitError(null)

    setTimeout(() => {
      handleSubmit(code)
    }, 1000)
  }

  useEffect(() => {
    if (ref.current && ref.current.iRefs && ref.current.iRefs[0] && ariaLabel) {
      ref.current.iRefs[0].current.setAttribute("aria-label", ariaLabel)
    }
  }, [ariaLabel])

  return (
    <StyledCodeWrapper>
      <StyledeInput
        ref={ref}
        type="number"
        fields={4}
        fieldHeight={56}
        fieldWidth={48}
        autoFocus
        onComplete={handleComplete}
        onChange={() => setDisabled(true)}
        $submitError={submitError}
      />
    </StyledCodeWrapper>
  )
}

export default StyledCodeInput
